var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":true,"variant":"light"}},[_c('div',{staticClass:"iq-alert-text",domProps:{"innerHTML":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }